/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Nee model module.
 * @module model/Nee
 * @version 1.0.0
 */
class Nee {
    /**
     * Constructs a new <code>Nee</code>.
     * Degree of student disability
     * @alias module:model/Nee
     * @param id {Number} 
     * @param name {String} 
     */
    constructor(id, name) { 
        
        Nee.initialize(this, id, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name) { 
        obj['id'] = id;
        obj['name'] = name;
    }

    /**
     * Constructs a <code>Nee</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Nee} obj Optional instance to populate.
     * @return {module:model/Nee} The populated <code>Nee</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Nee();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
Nee.prototype['id'] = undefined;

/**
 * @member {String} name
 */
Nee.prototype['name'] = undefined;






export default Nee;

